/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const VerticalDotsIcon = props => {
	const { color = '' } = props

	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 12 48' {...props}>
			<g transform='rotate(90 4.697 4.697)' fill={color}>
				<circle
					data-name='Elipse 1609'
					cx={4.697}
					cy={4.697}
					r={4.697}
					transform='translate(17.743)'
				/>
				<circle data-name='Elipse 1610' cx={4.697} cy={4.697} r={4.697} />
				<ellipse
					data-name='Elipse 1611'
					cx={4.175}
					cy={4.697}
					rx={4.175}
					ry={4.697}
					transform='translate(36.529)'
				/>
			</g>
		</svg>
	)
}

export default VerticalDotsIcon
